var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    !_vm.loading
      ? _c(
          "div",
          { staticClass: "settings" },
          [
            _c(
              "el-form",
              {
                ref: "settingsForm",
                attrs: { "label-position": "left", "label-width": "180px" },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("settings.username") } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c("el-input", {
                          attrs: { disabled: true },
                          model: {
                            value: _vm.$userInformation.user.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.$userInformation.user, "name", $$v)
                            },
                            expression: "$userInformation.user.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 16, offset: 1 } },
                      [
                        _c("el-input", {
                          attrs: { disabled: true },
                          model: {
                            value: _vm.$userData.company,
                            callback: function ($$v) {
                              _vm.$set(_vm.$userData, "company", $$v)
                            },
                            expression: "$userData.company",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("settings.customerkey") } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c("el-input", {
                          attrs: { disabled: true },
                          model: {
                            value: _vm.$userInformation.customerKey,
                            callback: function ($$v) {
                              _vm.$set(_vm.$userInformation, "customerKey", $$v)
                            },
                            expression: "$userInformation.customerKey",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("settings.country") } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c("el-input", {
                          attrs: { disabled: true },
                          model: {
                            value: _vm.$userData.country,
                            callback: function ($$v) {
                              _vm.$set(_vm.$userData, "country", $$v)
                            },
                            expression: "$userData.country",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-tabs",
              {
                staticClass: "tab-list",
                model: {
                  value: _vm.activeName,
                  callback: function ($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName",
                },
              },
              [
                _c(
                  "el-tab-pane",
                  {
                    attrs: { label: _vm.$t("settings.global"), name: "global" },
                  },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "settingsForm",
                        attrs: {
                          model: _vm.formData.global,
                          "label-position": "left",
                          "label-width": "300px",
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("settings.isChina") } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c("el-switch", {
                                  model: {
                                    value: _vm.formData.global.default10,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.global,
                                        "default10",
                                        $$v
                                      )
                                    },
                                    expression: "formData.global.default10",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { staticClass: "list-desc", attrs: { span: 24 } },
                              [
                                _c("span", [
                                  _c("i", [
                                    _vm._v(
                                      _vm._s(_vm.$t("settings.isChinaDesc"))
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("settings.clearCache") } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.clearRoutingCache.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("settings.clearCacheRoutingBtn")
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.clearDataCache.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("settings.clearCacheDataBtn")
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { staticClass: "list-desc", attrs: { span: 24 } },
                              [
                                _c("span", [
                                  _c("i", [
                                    _vm._v(
                                      _vm._s(_vm.$t("settings.clearCacheDesc"))
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("settings.startTime") } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c("el-time-picker", {
                                  attrs: {
                                    "picker-options": {
                                      selectableRange: "00:00:00 - 23:59:00",
                                    },
                                    clearable: true,
                                    "arrow-control": true,
                                    "value-format": "HH:mm",
                                  },
                                  model: {
                                    value: _vm.formData.global.default6,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.global,
                                        "default6",
                                        $$v
                                      )
                                    },
                                    expression: "formData.global.default6",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { staticClass: "list-desc", attrs: { span: 24 } },
                              [
                                _c("span", [
                                  _c("i", [
                                    _vm._v(
                                      _vm._s(_vm.$t("settings.startTimeDesc"))
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("settings.waitingTime") } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c("el-input-number", {
                                  attrs: { size: "small", min: 0 },
                                  model: {
                                    value: _vm.formData.global.default7,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.global,
                                        "default7",
                                        $$v
                                      )
                                    },
                                    expression: "formData.global.default7",
                                  },
                                }),
                                _vm._v(
                                  "  " +
                                    _vm._s(_vm.$t("dateRange.minutes")) +
                                    " "
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { staticClass: "list-desc", attrs: { span: 24 } },
                              [
                                _c("span", [
                                  _c("i", [
                                    _vm._v(
                                      _vm._s(_vm.$t("settings.waitingTimeDesc"))
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("settings.handlingTime") } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c("el-input-number", {
                                  attrs: { size: "small", min: 0 },
                                  model: {
                                    value: _vm.formData.global.default8,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.global,
                                        "default8",
                                        $$v
                                      )
                                    },
                                    expression: "formData.global.default8",
                                  },
                                }),
                                _vm._v(
                                  "  " +
                                    _vm._s(_vm.$t("dateRange.minutes")) +
                                    " "
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { staticClass: "list-desc", attrs: { span: 24 } },
                              [
                                _c("span", [
                                  _c("i", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("settings.handlingTimeDesc")
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "text-right" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled: _vm.helper.isEmpty(_vm.customerId),
                                  type: "primary",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.submitForm.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("settings.update")) + " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.hasPermission("lastMileDelivery") ||
                _vm.hasPermission("lastMileDeliveryPricerite") ||
                _vm.hasPermission("lastMileDeliveryWellcome") ||
                _vm.hasPermission("lastMileV2")
                  ? _c(
                      "el-tab-pane",
                      {
                        attrs: {
                          label: _vm.$t("settings.lastmiledelivery"),
                          name: "lastmiledelivery",
                        },
                      },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "settingsForm",
                            attrs: {
                              model: _vm.formData.lastmiledelivery,
                              "label-position": "left",
                              "label-width": "300px",
                            },
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("settings.timeWindowCheck"),
                                },
                              },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("el-switch", {
                                      model: {
                                        value:
                                          _vm.formData.lastmiledelivery
                                            .default2,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.lastmiledelivery,
                                            "default2",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.lastmiledelivery.default2",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "list-desc",
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("span", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "settings.timeWindowCheckDesc"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("settings.timeWindowGrouping"),
                                },
                              },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("el-switch", {
                                      attrs: {
                                        disabled:
                                          !_vm.formData.lastmiledelivery
                                            .default2,
                                      },
                                      model: {
                                        value:
                                          _vm.formData.lastmiledelivery
                                            .default24,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.lastmiledelivery,
                                            "default24",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.lastmiledelivery.default24",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "list-desc",
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("span", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "settings.timeWindowGroupingDesc"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: _vm.$t("settings.group") } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("el-switch", {
                                      model: {
                                        value:
                                          _vm.formData.lastmiledelivery
                                            .default4,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.lastmiledelivery,
                                            "default4",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.lastmiledelivery.default4",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "list-desc",
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("span", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(_vm.$t("settings.groupDesc"))
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: _vm.$t("settings.capacity") } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("el-switch", {
                                      model: {
                                        value:
                                          _vm.formData.lastmiledelivery
                                            .default9,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.lastmiledelivery,
                                            "default9",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.lastmiledelivery.default9",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "list-desc",
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("span", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("settings.capacityDesc")
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("settings.returnVehicle"),
                                },
                              },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("el-switch", {
                                      model: {
                                        value:
                                          _vm.formData.lastmiledelivery
                                            .default3,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.lastmiledelivery,
                                            "default3",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.lastmiledelivery.default3",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "list-desc",
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("span", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("settings.returnVehicleDesc")
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("settings.checkProcessingTime"),
                                },
                              },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("el-switch", {
                                      model: {
                                        value:
                                          _vm.formData.lastmiledelivery
                                            .default27,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.lastmiledelivery,
                                            "default27",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.lastmiledelivery.default27",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "list-desc",
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("span", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "settings.checkProcessingTimeDesc"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("settings.maxDistance"),
                                },
                              },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        size: "small",
                                        min: 1,
                                        max: 9999,
                                      },
                                      model: {
                                        value:
                                          _vm.formData.lastmiledelivery
                                            .default11,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.lastmiledelivery,
                                            "default11",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.lastmiledelivery.default11",
                                      },
                                    }),
                                    _vm._v("  km "),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "list-desc",
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("span", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("settings.maxDistanceDesc")
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("settings.totalMaxDistance"),
                                },
                              },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        size: "small",
                                        min: 100,
                                        max: 99999,
                                      },
                                      model: {
                                        value:
                                          _vm.formData.lastmiledelivery
                                            .default26,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.lastmiledelivery,
                                            "default26",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.lastmiledelivery.default26",
                                      },
                                    }),
                                    _vm._v("  km "),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "list-desc",
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("span", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "settings.totalMaxDistanceDesc"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "settings.additionalConstraints"
                                  ),
                                },
                              },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "w-100",
                                        attrs: {
                                          multiple: "",
                                          placeholder:
                                            _vm.$t("settings.select"),
                                        },
                                        model: {
                                          value:
                                            _vm.formData.lastmiledelivery
                                              .default12,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData.lastmiledelivery,
                                              "default12",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.lastmiledelivery.default12",
                                        },
                                      },
                                      _vm._l(
                                        [
                                          "capacity3",
                                          "maxOrders",
                                          "capacity4",
                                          "capacity5",
                                          "capacity6",
                                          "truckCommodityType",
                                        ],
                                        function (capValue) {
                                          return _c("el-option", {
                                            key: capValue,
                                            attrs: {
                                              label: _vm.$t(
                                                "settings." + capValue
                                              ),
                                              value: capValue,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "list-desc",
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("span", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "settings.additionalConstraintsDesc"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm.helper.isInArray(
                              "capacity3",
                              _vm.formData.lastmiledelivery.default12
                            )
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "settings.capacity3TimeBuffer"
                                      ),
                                    },
                                  },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c("el-input-number", {
                                          attrs: { size: "small" },
                                          model: {
                                            value:
                                              _vm.formData.lastmiledelivery
                                                .default15,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData.lastmiledelivery,
                                                "default15",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.lastmiledelivery.default15",
                                          },
                                        }),
                                        _vm._v(
                                          "  " +
                                            _vm._s(
                                              _vm.$t("dateRange.minutes")
                                            ) +
                                            " "
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      {
                                        staticClass: "list-desc",
                                        attrs: { span: 24 },
                                      },
                                      [
                                        _c("span", [
                                          _c("i", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "settings.capacity3TimeBufferDesc"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.helper.isInArray(
                              "truckCommodityType",
                              _vm.formData.lastmiledelivery.default12
                            )
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "settings.truckCommodityTypeMapping"
                                      ),
                                    },
                                  },
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        staticClass: "truck-commodity-header",
                                        attrs: { span: 7 },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "settings.truckCommodityType"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-col",
                                      {
                                        staticClass: "truck-commodity-header",
                                        attrs: { span: 17 },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "settings.orderCommodityType"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _vm._l(
                                      _vm.formData.lastmiledelivery.default16,
                                      function (defaultVal, defaultIdx) {
                                        return _c(
                                          "div",
                                          { key: defaultIdx },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 6 } },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder: _vm.$t(
                                                      "settings.truckCommodityType"
                                                    ),
                                                  },
                                                  model: {
                                                    value: defaultVal["truck"],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        defaultVal,
                                                        "truck",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "defaultVal['truck']",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              {
                                                staticClass: "text-center",
                                                attrs: { span: 1 },
                                              },
                                              [_vm._v("-")]
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 15 } },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder: _vm.$t(
                                                      "settings.orderCommodityType"
                                                    ),
                                                  },
                                                  model: {
                                                    value:
                                                      defaultVal["commodity"],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        defaultVal,
                                                        "commodity",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "defaultVal['commodity']",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              {
                                                staticClass: "text-center",
                                                attrs: { span: 2 },
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: defaultIdx === 0,
                                                      expression:
                                                        "defaultIdx === 0",
                                                    },
                                                  ],
                                                  staticClass: "mt-1",
                                                  style: { color: "#14AF1B" },
                                                  attrs: {
                                                    icon: "plus-circle",
                                                    size: "2x",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.addTruckCommodityType.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                  },
                                                }),
                                                _c("font-awesome-icon", {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: defaultIdx >= 1,
                                                      expression:
                                                        "defaultIdx >= 1",
                                                    },
                                                  ],
                                                  staticClass: "mt-1",
                                                  style: { color: "#DC3545" },
                                                  attrs: {
                                                    icon: "minus-circle",
                                                    size: "2x",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.removeTruckCommodityType(
                                                        defaultIdx
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    _c(
                                      "el-col",
                                      {
                                        staticClass: "list-desc",
                                        attrs: { span: 24 },
                                      },
                                      [
                                        _c("span", [
                                          _c("i", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "settings.truckCommodityTypeMappingDesc"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("settings.travelTimePadding"),
                                },
                              },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        size: "small",
                                        min: 0,
                                        max: 100,
                                      },
                                      model: {
                                        value:
                                          _vm.formData.lastmiledelivery
                                            .default29,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.lastmiledelivery,
                                            "default29",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.lastmiledelivery.default29",
                                      },
                                    }),
                                    _vm._v("  % "),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "list-desc",
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("span", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "settings.travelTimePaddingDesc"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("settings.capacityPadding"),
                                },
                              },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        size: "small",
                                        min: 0,
                                        max: 100,
                                      },
                                      model: {
                                        value:
                                          _vm.formData.lastmiledelivery
                                            .default33,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.lastmiledelivery,
                                            "default33",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.lastmiledelivery.default33",
                                      },
                                    }),
                                    _vm._v("  % "),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "list-desc",
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("span", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "settings.capacityPaddingDesc"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("settings.optimizeTruck"),
                                },
                              },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("el-switch", {
                                      model: {
                                        value:
                                          _vm.formData.lastmiledelivery
                                            .default20,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.lastmiledelivery,
                                            "default20",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.lastmiledelivery.default20",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "list-desc",
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("span", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("settings.optimizeTruckDesc")
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("settings.reuseNoZoneVehicles"),
                                },
                              },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("el-switch", {
                                      model: {
                                        value:
                                          _vm.formData.lastmiledelivery
                                            .default28,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.lastmiledelivery,
                                            "default28",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.lastmiledelivery.default28",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "list-desc",
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("span", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "settings.reuseNoZoneVehiclesDesc"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("settings.truckPadding"),
                                },
                              },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        size: "small",
                                        min: 0,
                                        max: 100,
                                      },
                                      model: {
                                        value:
                                          _vm.formData.lastmiledelivery
                                            .default17,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.lastmiledelivery,
                                            "default17",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.lastmiledelivery.default17",
                                      },
                                    }),
                                    _vm._v("  % "),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "list-desc",
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("span", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("settings.truckPaddingDesc")
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("settings.priorityCount"),
                                },
                              },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("el-input-number", {
                                      attrs: { size: "small", min: 1, max: 3 },
                                      model: {
                                        value:
                                          _vm.formData.lastmiledelivery
                                            .default25,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.lastmiledelivery,
                                            "default25",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.lastmiledelivery.default25",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "list-desc",
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("span", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("settings.priorityCountDesc")
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "text-right" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      disabled: _vm.helper.isEmpty(
                                        _vm.customerId
                                      ),
                                      type: "primary",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.submitForm.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("settings.update")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.hasPermission("milkRun") || _vm.hasPermission("milkRunV2")
                  ? _c(
                      "el-tab-pane",
                      {
                        attrs: {
                          label: _vm.$t("settings.milkrun"),
                          name: "milkrun",
                        },
                      },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "settingsForm",
                            attrs: {
                              model: _vm.formData.milkrun,
                              "label-position": "left",
                              "label-width": "300px",
                            },
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "settings.milkRunPushNotification"
                                  ),
                                },
                              },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("el-switch", {
                                      model: {
                                        value: _vm.formData.milkrun.default21,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.milkrun,
                                            "default21",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.milkrun.default21",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "list-desc",
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("span", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "settings.milkRunPushNotificationDesc"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("settings.timeInterval"),
                                },
                              },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        size: "small",
                                        min: 10,
                                        max: 300,
                                        step: 10,
                                      },
                                      model: {
                                        value: _vm.formData.milkrun.default14,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.milkrun,
                                            "default14",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.milkrun.default14",
                                      },
                                    }),
                                    _vm._v(
                                      "  " +
                                        _vm._s(_vm.$t("dateRange.seconds")) +
                                        " "
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "list-desc",
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("span", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("settings.timeIntervalDesc")
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("settings.alertLateInterval"),
                                },
                              },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        size: "small",
                                        min: 60,
                                        max: 300,
                                        step: 10,
                                      },
                                      model: {
                                        value: _vm.formData.milkrun.default22,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.milkrun,
                                            "default22",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.milkrun.default22",
                                      },
                                    }),
                                    _vm._v(
                                      "  " +
                                        _vm._s(_vm.$t("dateRange.seconds")) +
                                        " "
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "list-desc",
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("span", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "settings.alertLateIntervalDesc"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("settings.alertErrorInterval"),
                                },
                              },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        size: "small",
                                        min: 60,
                                        max: 3600,
                                        step: 10,
                                      },
                                      model: {
                                        value: _vm.formData.milkrun.default23,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.milkrun,
                                            "default23",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.milkrun.default23",
                                      },
                                    }),
                                    _vm._v(
                                      "  " +
                                        _vm._s(_vm.$t("dateRange.seconds")) +
                                        " "
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "list-desc",
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("span", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "settings.alertErrorIntervalDesc"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "text-right" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.submitForm.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("settings.update")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.hasPermission("railway")
                  ? _c(
                      "el-tab-pane",
                      {
                        attrs: {
                          label: _vm.$t("settings.railway"),
                          name: "railway",
                        },
                      },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "settingsForm",
                            attrs: {
                              model: _vm.formData.railway,
                              "label-position": "left",
                              "label-width": "300px",
                            },
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: _vm.$t("settings.planCode") } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _vm._l(
                                      _vm.formData.railway.default19,
                                      function (plancode) {
                                        return _c(
                                          "el-tag",
                                          {
                                            key: plancode,
                                            staticClass: "mr-3",
                                            attrs: {
                                              closable: "",
                                              "disable-transitions": false,
                                            },
                                            on: {
                                              close: function ($event) {
                                                return _vm.default19Close(
                                                  plancode
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(" " + _vm._s(plancode) + " ")]
                                        )
                                      }
                                    ),
                                    _vm.default19Visible
                                      ? _c("el-input", {
                                          ref: "saveDefault19Input",
                                          staticClass: "input-new-tag",
                                          attrs: {
                                            size: "mini",
                                            placeholder: _vm.$t(
                                              "settings.addPlanCodePlaceholder"
                                            ),
                                          },
                                          on: {
                                            blur: _vm.default19InputConfirm,
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.default19InputConfirm.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.default19Value,
                                            callback: function ($$v) {
                                              _vm.default19Value = $$v
                                            },
                                            expression: "default19Value",
                                          },
                                        })
                                      : _c(
                                          "el-button",
                                          {
                                            staticClass: "button-new-tag",
                                            attrs: { size: "small" },
                                            on: {
                                              click: _vm.default19ShowInput,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " + " +
                                                _vm._s(
                                                  _vm.$t("settings.addPlanCode")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                  ],
                                  2
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "list-desc",
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("span", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("settings.planCodeDesc")
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("settings.timeInterval"),
                                },
                              },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        size: "small",
                                        min: 30,
                                        max: 300,
                                        step: 10,
                                      },
                                      model: {
                                        value: _vm.formData.railway.default18,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.railway,
                                            "default18",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.railway.default18",
                                      },
                                    }),
                                    _vm._v(
                                      "  " +
                                        _vm._s(_vm.$t("dateRange.seconds")) +
                                        " "
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "list-desc",
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("span", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("settings.timeIntervalDesc")
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "text-right" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.submitForm.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("settings.update")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }